import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import GoalForm from "@/components/GoalForm";

export default function GoalFormModal({ meta, open, onClose, onSaved }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="goal-form-modal" className="max-w-xl max-h-[92vh] overflow-y-auto rounded-2xl p-6 sm:p-8">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl font-bold text-slate-900">
            {meta ? "Editar Meta" : "Nova Meta"}
          </DialogTitle>
          <DialogDescription className="text-base text-slate-600">
            O documento visual (guia Pix) é regenerado automaticamente ao salvar.
          </DialogDescription>
        </DialogHeader>
        <GoalForm meta={meta} submitLabel={meta ? "SALVAR ALTERAÇÕES" : "GERAR BOLETO / META"} onSaved={onSaved} />
      </DialogContent>
    </Dialog>
  );
}
